export default class ResponsiveVideo {
	constructor(video) {
		this.video = video;
		this.width = this.video.getBoundingClientRect().width * window.devicePixelRatio; // Get width taking pixel density into account

		this.pickSource();
	}

	static init(){
		document.querySelectorAll('[data-video]').forEach((video) => {
			new ResponsiveVideo(video);
		});
	}

	pickSource() {
		const sources = this.video.querySelectorAll('source');

		const sortedSources = [...sources].map(source => {
			// Get source resolution (by provided by data attribute)
			const sourceWidth = source.dataset.sourcewidth || 0;

			//remove
			source.remove();

			return {
				src: source.src,
				diff: Math.abs(sourceWidth - this.width)
			};
		})
		.sort((a, b) => a.diff - b.diff);

		const matchedSource = sortedSources[0];

		if(!matchedSource){
			return;
		}

		setTimeout(() => {
			this.video.src = matchedSource.src;
		}, 0);
	}
}